import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
  imports: [RouterModule, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFooterComponent {
  readonly variant = input<'auth' | 'dashboard'>('dashboard');

  readonly currentYear = new Date().getFullYear();
}
